export default class NotFoundPresenter {
  constructor(model, view, appInterface) {
    this.view = view;
    this.appInterface = appInterface;
  }

  async init() {
    if (this.view.setBackHomeHandler) {
      this.view.setBackHomeHandler(() => this.appInterface.navigateTo('home'));
    }
  }

  cleanup() {
    if (this.view.cleanup) this.view.cleanup();
  }
}
